export default __webpack_public_path__ + "static/media/companies-la-nacion.ff83af88.svg";